const prefix = '/api/v1/global-market' as const;

export const globalMarketPaths = {
  indices: `${prefix}/indices`,
  commodities: `${prefix}/commodities`,
} as const;
